<app-notification></app-notification>
<ng-container *ngIf="url | async">
    <app-svg-icons></app-svg-icons>
    <app-top-menu [iconsName] = "iconsNameActive" (theClick)="togleLeftMenu($event)"></app-top-menu>
    <app-left-menu [iconsName] = "iconsNameActive"></app-left-menu>
</ng-container>

<div [ngClass]="{contentIconsActive: iconsNameActive}">
	<router-outlet></router-outlet>
</div>